<template>
  <div class="container">
    <div class="row align-content-center justify-content-center text-center px-3">
      <m-icon icon="arrow-right-circle" class="cursor-pointer h4" @click="changeSelectedMonth('down')"/>
      <div class="col">{{ getDateMonthAndYear(calenderMonths[monthRange]) }}</div>
      <m-icon icon="arrow-left-circle" class="cursor-pointer h4" @click="changeSelectedMonth('up')"/>
    </div>
  </div>
</template>

<script>
import mIcon from '../../Icons/Icon.vue'
import {addMonths, getNextMonths} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Reservation";

export default {
  name: "ReservationMonthManager",
  components: {mIcon},
  data() {
    return {
      calenderMonths: [],
      monthRange: 0
    }
  },
  methods: {
    addMonths,
    getNextMonths,
    changeSelectedMonth(mode = 'up') {
      if (mode === 'up' && [0, 1].indexOf(this.monthRange) > -1) {
        this.monthRange += 1
        this.currentMonths()
      }
      if (mode === 'down' && [1, 2].indexOf(this.monthRange) > -1) {
        this.monthRange -= 1
        this.currentMonths()
      }
    },
    getDateMonthAndYear(date) {
      return new Date(date).toLocaleDateString('fa-IR-u-nu-latn', {year: 'numeric', month: 'long'});
    },
    currentMonths() {
      this.$emit('month', this.calenderMonths[this.monthRange])
    }
  },
  mounted() {
    this.calenderMonths = this.getNextMonths()
    this.currentMonths()
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>